/*
 * DefaultCourseMapperAdmin Messages
 *
 * This contains all the text for the DefaultCourseMapperAdmin component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    year: {
        id: 'app.components.DefaultCourseMapperAdmin.year',
        defaultMessage: 'YEAR'
    },
    defaultCourse: {
        id: 'app.components.DefaultCourseMapperAdmin.defaultCourse',
        defaultMessage: 'DEFAULT COURSE'
    },
    newDefaultCourse: {
        id: 'app.components.DefaultCourseMapperAdmin.newDefaultCourse',
        defaultMessage: 'NEW DEFAULT COURSE'
    },
    queue: {
        id: 'app.components.DefaultCourseMapperAdmin.queue',
        defaultMessage: 'Queue'
    },
    cancel: {
        id: 'app.components.DefaultCourseMapperAdmin.cancel',
        defaultMessage: 'Cancel'
    },
    assignToGroup: {
        id: 'app.components.DefaultCourseMapperAdmin.assignToGroup',
        defaultMessage: 'Assign to year'
    },
    unsavedChanges: {
        id: 'app.components.DefaultCourseMapperAdmin.unsavedChanges',
        defaultMessage: 'Unsaved changes'
    },
    learningModule: {
        id: 'app.components.DefaultCourseMapperAdmin.learningModule',
        defaultMessage: 'LEARNING MODULE'
    },
    skillQuests: {
        id: 'app.components.DefaultCourseMapperAdmin.skillQuests',
        defaultMessage: 'Skill Quests'
    },
    coursesActivityMastery: {
        id: 'app.components.DefaultCourseMapperAdmin.coursesActivityMastery',
        defaultMessage: 'Courses (Activity Mastery)'
    },
    courses: {
        id: 'app.components.DefaultCourseMapperAdmin.courses',
        defaultMessage: 'Courses'
    },
    unconfirmed: {
        id: 'app.components.DefaultCourseMapperAdmin.unconfirmed',
        defaultMessage: '(Confirm by selecting queue)'
    },
    optedOut: {
        id: 'app.components.DefaultCourseMapperAdmin.optedOut',
        defaultMessage: 'Opted out'
    },
    noVoluntaryCourseSet: {
        id: 'app.components.DefaultCourseMapperAdmin.noVoluntaryCourseSet',
        defaultMessage: 'No voluntary course set'
    },
    queuedForRollover: {
        id: 'app.components.DefaultCourseMapperAdmin.queuedForRollover',
        defaultMessage: 'Queued for Rollover'
    },
    whileYouMightSee: {
        id: 'app.components.DefaultCourseMapperAdmin.whileYouMightSee',
        defaultMessage: 'While you might see your selection displayed under'
    },
    changesWillNotTake: {
        id: 'app.components.DefaultCourseMapperAdmin.changesWillNotTake',
        defaultMessage: 'changes will not take effect until your next scheduled rollover.'
    },
    youMayChangeYour: {
        id: 'app.components.DefaultCourseMapperAdmin.youMayChangeYour',
        defaultMessage: 'You may change your selection at any point prior to rollover.'
    },
    iUnderstand: {
        id: 'app.components.DefaultCourseMapperAdmin.iUnderstand',
        defaultMessage: 'I understand'
    },
    dontTellMeAgain: {
        id: 'app.components.DefaultCourseMapperAdmin.dontTellMeAgain',
        defaultMessage: 'Don\'t tell me again'
    }
});



// WEBPACK FOOTER //
// ./app/components/default-course-mapper-admin/messages.js